module.exports = __webpack_public_path__ + "612edd020d6ad61ebccffeefd62eb81f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-10.png
// module id = 3100
// module chunks = 0